import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonNew as Button } from "components/buttonNew";
import Input from "components/form/input/Input";
import { WebsiteBuilderHelpIcon } from "pages/secure/facility/websiteBuilder/editor/components/helpIcon/WebsiteBuilderHelpIcon";
import { IWebsiteBuilderSlideshowImage } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderSlideshow";
import React from "react";
import { useTranslation } from "react-i18next";

interface ISlideshowImagesAltTextViewProps {
  nextSelectedImages: IWebsiteBuilderSlideshowImage[];
  setNextSelectedImages: (nextSelectedImages: IWebsiteBuilderSlideshowImage[]) => void;
}

export function SlideshowImagesAltTextView(props: ISlideshowImagesAltTextViewProps) {
  const { nextSelectedImages, setNextSelectedImages } = props;

  const { t } = useTranslation();

  function updateAltText(index: number, alt: string) {
    setNextSelectedImages(nextSelectedImages.map((image, imageIndex) => imageIndex === index ? {
      ...image,
      alt,
    } : image));
  }

  function clearAltTexts() {
    setNextSelectedImages(nextSelectedImages.map(image => ({
      ...image,
      alt: "",
    })));
  }

  return (
    <div className="website-builder-slideshow-images-alt-text">
      <div className="slideshow-images-alt-text-header">
        <Button type="text" onClick={clearAltTexts}>
          <FontAwesomeIcon icon={faXmark} />&nbsp;{t("Clear all")}
        </Button>
        <div className="slideshow-images-alt-text-total">
          {t(nextSelectedImages.length === 1 ? "1 image selected" : "{{imageCount}} images selected", {
            imageCount: nextSelectedImages.length,
          })}
        </div>
      </div>

      <div className="slideshow-images-alt-text-list">
        {nextSelectedImages.map((image, index) => (
          <div
            key={image.mediaId}
            className="slideshow-images-alt-text-item"
          >
            <img
              src={image.src}
              alt={image.alt}
            />
            <div className="slideshow-images-alt-text-input">
              <Input
                label={t("Alt text (optional)")}
                suffix={
                  <WebsiteBuilderHelpIcon
                    id={`website-builder-slideshow-images-alt-text-input-help-${image.mediaId}`}
                    message={t("Improves accessibility and helps search engines understand the image.")}
                    placement="left"
                  />
                }
                value={image.alt}
                placeholder={t("E.g., Golf course with green trees")}
                onChange={e => updateAltText(index, e.target.value)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
